import { IFormField } from 'models/app';
import React from 'react';
import Modal from 'components/UI/DialogModal';
import Form from 'components/UI/Form';
import { CircularProgress, Grid, Stack } from '@mui/material';
import MuiButton from 'components/UI/MuiButton';
import { InputTypes } from 'constants/enums';
import { IPolicy } from 'models/policy';
import { IFaqs } from 'models/faqs';




interface Props {
  open: boolean;
  loading: boolean;
  basicFields: IFormField[];
  title: string;
  disabled?: boolean;
  onClose: () => void;
  onSubmit: () => void;
  onChanges: (name: string, value: any) => void;
}




const EditModalReseller: React.FC<Props> = ({ open, loading, basicFields, title, disabled, onClose, onSubmit, onChanges }) => {
  return (<>

    <Modal
      open={open}
      onClose={onClose}
      title={title}
      maxWidth="lg"
      children={<Stack spacing={2} p={2} >
        <Form fields={basicFields} onChange={onChanges} />
      </Stack>}
      actions={
        <Grid container alignItems={'center'} justifyContent={'space-between'} px={1} >
          <MuiButton variant="contained"
            sx={{ bgcolor: 'warning.main', color: 'white' }}
            size='large' onClick={onClose}>
            {'Cancel'}
          </MuiButton>
          <MuiButton variant="contained"
            sx={{ bgcolor: 'primary.main', color: 'white' }}
            disabled={loading || disabled}
            size='large' onClick={onSubmit}>
            {'Edit'}
            <CircularProgress
              size={10}
              sx={{ mx: 2, display: loading ? "" : "none" }}
            />
          </MuiButton>

        </Grid>
      }
    />
  </>
  );
};

export default EditModalReseller;
